import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcDownload = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	color: "inherit",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.33203 13.3333H12.6654V12H3.33203V13.3333ZM12.6654 6H9.9987V2H5.9987V6H3.33203L7.9987 10.6667L12.6654 6Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgIcDownload);
export default ForwardRef;
